import clsx from "clsx";
import { Link, useLocation } from "react-router";
import { GameVer, stripRealm, tturl, useRealm } from "~/util/Lang";
import css from "./GverMenu.module.css";

export function GverMenu() {
  const realm = useRealm();
  const loc = useLocation();
  const path = stripRealm(loc.pathname);

  const items = GameVer.options;

  return (
    <div className={css.root}>
      <div className={css.container}>
        {items.map((item) => {
          return (
            <Link
              key={item}
              className={clsx(css.item, {
                [css.itemActive]: realm.game === item,
              })}
              to={{
                pathname: tturl({ ...realm, game: item }, path),
                search: loc.search,
              }}
            >
              {item.toUpperCase()}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
